const REVOKE_DELAY_MS = 100;

/**
 * Downloads a file by fetching its URL and triggering a browser download.
 */
export async function downloadFile(url: string, fileName: string) {
  const res = await fetch(url);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  setTimeout(() => {
    URL.revokeObjectURL(objectUrl);
  }, REVOKE_DELAY_MS);
}
